import React, { useState, useEffect } from "react";
import "./Projects.css";
import { client, urlFor } from "../../client";
import Laptop from "../3D-Laptop/Laptop";
import ProjectCard from "./ProjectCard";
import ProjectCard2 from "./ProjectCard2";

const Projects = () => {
  const [showAllProjects, setShowAllProjects] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("webdev");
  const [projectsData, setProjectsData] = useState([]);
  const [featuredProjects, setFeaturedProjects] = useState([]);

  const categoryMapping = {
    webdev: "Web Development",
    python: "Python",
    app: "App Development",
    graphic: "Graphic Design",
    data: "Data Analysis",
  };

  useEffect(() => {
    const query = '*[_type == "projects"]';

    client.fetch(query).then((data) => {
      // Sort projects by orderNo if available, then randomly otherwise
      const sortedProjects = data.sort((a, b) => {
        if (a.orderNo && b.orderNo) {
          return a.orderNo - b.orderNo;
        } else if (a.orderNo) {
          return -1; // Place projects with orderNo first
        } else if (b.orderNo) {
          return 1; // Place projects with orderNo first
        } else {
          return Math.random() - 0.5; // Random order for projects without orderNo
        }
      });

      setProjectsData(sortedProjects);

      // Example: List of orderNo for featured projects
      const featuredOrderNos = [1,2];
      const featuredProjects = sortedProjects.filter((project) =>
        featuredOrderNos.includes(project.orderNo)
      );

      setFeaturedProjects(featuredProjects);
    });
  }, []);

  const toggleProjects = () => {
    setShowAllProjects((prevShowAllProjects) => !prevShowAllProjects);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const filteredProjects = projectsData.filter(
    (project) =>
      selectedCategory === "all" ||
      (project.category && project.category.includes(selectedCategory))
  ).filter(
    (project) => !featuredProjects.some(
      (featuredProject) => featuredProject.orderNo === project.orderNo
    )
  ); // Adjusted the rendering logic to ensure non-duplication

  return (
    <>
      <section className="project" id="portfolio">
        <div className="project-content section-content">
          <p className="section-subtitle">My Works</p>
          <h2 className="h3 section-title">
            See My Works Which Will Amaze You!
          </h2>
          <p className="section-text section-title">
            I develop the best quality website that serves for the long-term.
            Well-documented, clean, easy and elegant interface helps any
            non-technical clients.
          </p>
        </div>

        <Laptop />

        {/* Featured Projects */}
        {featuredProjects.length > 0 && (
          <ProjectCard2 featuredProjects={featuredProjects} />
        )}

        {projectsData.length > 0 && (
          <div className="filter-buttons">
            <button
              className={selectedCategory === "webdev" ? "active" : ""}
              onClick={() => handleCategoryChange("webdev")}
            >
              Web Development
            </button>
            <button
              className={selectedCategory === "python" ? "active" : ""}
              onClick={() => handleCategoryChange("python")}
            >
              Python
            </button>
            <button
              className={selectedCategory === "app" ? "active" : ""}
              onClick={() => handleCategoryChange("app")}
            >
              App Development
            </button>
            <button
              className={selectedCategory === "graphic" ? "active" : ""}
              onClick={() => handleCategoryChange("graphic")}
            >
              Graphic Design
            </button>
            <button
              className={selectedCategory === "data" ? "active" : ""}
              onClick={() => handleCategoryChange("data")}
            >
              Data Analysis
            </button>
          </div>
        )}

        {projectsData.length > 0 ? (
          <ul className="cards">
            {filteredProjects
              .slice(0, showAllProjects ? filteredProjects.length : 4)
              .map((project, index) => (
                <ProjectCard
                  key={index}
                  imgUrl={
                    project.imgUrl
                      ? urlFor(project.imgUrl)
                      : "https://designimages.appypie.com/favicon/circularfavicon-8-animal-sealife.jpg"
                  }
                  title={project.title}
                  category={categoryMapping[project.category]}
                  description={project.description || project.shortDescription}
                  projectLink={project.projectLink}
                  shortDescription={
                    project.shortDescription || project.description
                  }
                  faviconUrl={
                    project.faviconUrl
                      ? urlFor(project.faviconUrl)
                      : "https://designimages.appypie.com/favicon/circularfavicon-8-animal-sealife.jpg"
                  }
                  githubLink={project.githubUrl}
                />
              ))}
          </ul>
        ) : (
          <div className="mini-loader1 load-more"></div>
        )}
        {filteredProjects.length > 4 && (
          <button
            className="load-more btn btn-secondary"
            onClick={toggleProjects}
          >
            {showAllProjects ? "Show Less" : "Load More"}
          </button>
        )}
      </section>
    </>
  );
};

export default Projects;
